<template>
  <div :id="'element_' + _uid" dir="rtl" style="text-align: right;">
    <p class="bold">{{ question.info.applicant_text }}</p>
    <div style="margin: 0;" :key="option.id" v-for="option in sorted_options">
      <checkbox
        style="margin-bottom: 12px;"
        :id="option.id"
        @input="picked()"
        :checked="answered_option_ids.includes(option.id)"
        >{{ option.text }}</checkbox
      >
    </div>
  </div>
</template>
<script>
import QuestionsHelper from '@/custom/classes/questions_helper'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'question',
  props: {
    question: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      answered_option_ids: [],
      question_value: '',
      sorted_options: this.question.options
    }
  },
  created () {
    this.sorted_options.sort(this.optionOrderSorter)
  },
  mounted () {
    this.answered_option_ids = this.questions_helper.getAnsweredOptionIdsFromQuestion(
      this.question
    )
    this.$nextTick(() => {
      this.setQuestionValue()
    })
  },
  methods: {
    toggle () {
      this.$emit('input', !this.checked)
    },
    picked () {
      this.setQuestionValue()
    },
    setQuestionValue () {
      let question_value = []
      let checkboxes = document.querySelectorAll(
        '#element_' + this._uid + ' input[type=checkbox]:checked'
      )
      for (let i = 0; i < checkboxes.length; i++) {
        question_value.push(checkboxes[i].parentNode.getAttribute('id'))
      }
      this.question_value = question_value.join(',')
      this.$emit('input', this.question_value)
      this.$emit('question', {
        question: this.question,
        designator: this.question.designator,
        answer: this.question_value
      })
    },
    optionOrderSorter (option_1, option_2) {
      if (option_1.option_order < option_2.option_order) { return -1 }
      if (option_1.option_order > option_2.option_order) { return 1 }
      return 0
    }
  },
  components: {
    Checkbox
  }
}
</script>
